import { BASIC_HOTKEY_ACTIONS, HOTKEY_ACTIONS, HotkeyActionsMap } from './hotkeyActions';
import { useHotkeyCustomizationEnabled } from './useHotkeyCustomizationEnabled';

/**
 * The hotkey actions available in the current experience: the full
 * customizable set while the `hot-keys-customization` flag is on, otherwise
 * the fixed basic set.
 */
export function useHotkeyActions(): HotkeyActionsMap {
  const customizationEnabled = useHotkeyCustomizationEnabled();
  return customizationEnabled ? HOTKEY_ACTIONS : BASIC_HOTKEY_ACTIONS;
}
